import { http } from "../src/utils/index";

// 保存农事记录
export const saveRecordApi = (data:object) => {
    return http({
        url:`/cooperationH5/farming/record/index`,
        method:'POST',
        data
    })
}
// 更新农事记录
export const updateRecordApi = (data:object) => {
    return http({
        url:`/cooperationH5/farming/record/index`,
        method:'PUT',
        data
    })
}
// 删除农事记录
export const delRecordApi = (id:string) => {
    return http({
        url:`/cooperationH5/farming/record/index?id=${id}`,
        method:'DELETE',
    })
}
// 获取农事记录
export const getRecordApi = (id:string) => {
    return http({
        url:`/cooperationH5/farming/record/index?id=${id}`,
        method:'GET',
    })
}